import { Component } from '@angular/core';
import {environment} from '../../../../environments/environment'

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      <!-- Creado por <b><a href="http://www.natcomcuu.com" target="_blank">Natcom CUU</a></b> 2021 -->
      {{appName}} {{appVersion}} | <a href="{{apiDocumentation}}"target="_blank">API Documentation</a>
    </span>
    <!-- <div class="socials">
      <a href="#" target="_blank" class="ion ion-social-github"></a>
      <a href="#" target="_blank" class="ion ion-social-facebook"></a>
      <a href="#" target="_blank" class="ion ion-social-twitter"></a>
      <a href="#" target="_blank" class="ion ion-social-linkedin"></a>
    </div> -->
  `,
})
export class FooterComponent {
  appName:string = environment.appName;
  apiDocumentation:string = environment.apiDocumentation;
  appVersion: string = environment.appVersion
}
